module.exports = __webpack_public_path__ + "assets/img/statis-running.18dae640.svg";